export default __webpack_public_path__ + "static/media/CNo.90-3.f69fdb47.jpg";